import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import CloseAccountContent from 'src/app/CloseAccountContent/CloseAccountContent'
import {
  selectCreditCard,
  selectCreditCardIdFromRoute,
} from 'src/app/CloseAccountContent/redux/closeAccountContent.selectors'
import { useFlyoutDispatch } from 'src/hooks'
import {
  getCreditCard,
  getCreditCardPermissions,
} from 'src/redux/actions/data/creditCards.actions'

const CloseAccount: React.FC = (): React.ReactElement => {
  const dispatch = useFlyoutDispatch()
  const creditCardId = useSelector(selectCreditCardIdFromRoute)
  const creditCard = useSelector(selectCreditCard)

  useEffect((): void => {
    dispatch(getCreditCard(creditCardId))
    dispatch(getCreditCardPermissions(creditCardId))
  }, [creditCard?.status, creditCardId])

  useEffect(() => {
    if (creditCard === undefined) return
  }, [creditCard])

  return (
    <CloseAccountContent creditCardId={creditCardId} creditCard={creditCard} />
  )
}

export default CloseAccount
